import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Loader, NotificationCloseButton } from 'components/Base';

import { LoadingType, RootState } from 'handlers';

import { ToastContainer } from 'react-toastify';

import { EnvironmentValue, env } from 'env';

import initHotjar from 'utils/initHotjar';

import logo from './images/logo.svg';

import styles from './MainLayout.module.scss';

const MainLayout = () => {
  const loading = useSelector((state: RootState) => state.loading[LoadingType.ApplicationUpdating]);

  useEffect(() => {
    if (env.REACT_APP_ENVIRONMENT === EnvironmentValue.Prod) {
      initHotjar();
    }
  }, []);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.main_container}>
          <img src={logo} className={styles.logo_header} alt="logo" />
        </div>
      </div>
      <div className={styles.main}>
        <Outlet />
      </div>
      <div className={styles.footer}>
        <div className={styles.main_container}>
          <div className={styles.company_logo}>
            <img src={logo} className={styles.logo_footer} alt="logo" />
          </div>
          <div className={styles.company_info}>
            <p>
              <span className={styles.info_date}>© {new Date().getFullYear()}, </span>
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/">
                Republic Finance
              </a>
            </p>
            <div className={styles.links}>
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/legal">
                Legal & Privacy
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/disclosure">
                Disclosures
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/resources/faq">
                FAQ
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/learn/affiliations">
                Affiliations
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/learn/terms-to-know">
                Terms to Know
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/resources/news">
                News & Updates
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://www.republicfinance.com/contact">
                Contact
              </a>{' '}
              |{' '}
              <a target="_blank" rel="noopener noreferrer" href="https://jobs.republicfinance.com/">
                Careers
              </a>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader fullScreen />}
      <ToastContainer closeButton={NotificationCloseButton} />
    </>
  );
};

export default MainLayout;
